import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { emptySpacesValidator } from '@app/validators/empty-spaces-validator';
import { validateYear } from '@app/validators/year-validator';
import { StrategyService } from '@shared/services/strategy.service';
import { ToastNotificationService } from '@shared/services/toast-notification.service';
import { allowNumericInputOnly } from '@shared/utils';

@Component({
  selector: 'app-fund-kids-form',
  templateUrl: './fund-kids-form.component.html',
  styleUrls: ['./fund-kids-form.component.scss'],
  standalone: false
})
export class FundKidsFormComponent implements OnInit {
  @Input() firstName: string;
  childForm: FormGroup;
  allowNumericInputOnly = allowNumericInputOnly;

  constructor(
    private formBuilder: FormBuilder,
    private strategyService: StrategyService,
    private toastNotificationService: ToastNotificationService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.childForm = this.formBuilder.group({
      owner_name: [this.firstName, Validators.compose([Validators.required, Validators.minLength(2), emptySpacesValidator])],
      gender: ['', Validators.required],
      year_of_birth: ['', Validators.compose([Validators.required, validateYear])]
    });

    this.strategyService.getAccountExtraDetail().subscribe((value) => {
      if (value.data?.attributes?.extra_data?.gender && value.data?.attributes?.extra_data?.year_of_birth) {
        this.childForm.patchValue({
          owner_name: value.data.attributes.owner_name,
          ...value.data.attributes.extra_data
        });
      }
    });
  }

  saveChildInfo(): void {
    if (this.childForm.invalid) {
      return;
    }

    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
    this.strategyService.updateKidsAccountDetail({ ...this.childForm.value }).subscribe(() => {
      this.toastNotificationService.show('success', this.translateService.instant('profile.personalDetails.success.kidDetails') as string);
    });
  }
}
